module.exports = __webpack_public_path__ + "img/11-image001@2x.f2ef3f2e.png";